module.exports = __webpack_public_path__ + "img/05_speaker1.0e305f62.png";